import { Facet, KeyFacet, subKeyPart, stringPart, numberPart } from '@ms/items-view';

export const sentByFacet: Facet<string> = new Facet('filesViewSentBy');

export const subjectFacet: Facet<string> = new Facet('filesViewSubject');

export const recievedDateFacet: Facet<string> = new Facet('filesViewRecievedDate');

export const folderFacet: Facet<string> = new Facet('filesViewFolder');

export const mailboxKeyFacet: KeyFacet<{
    smtp: string;
}> = new KeyFacet('mailbox', {
    smtp: stringPart(),
});

export const mailboxFileSetKeyFacet: KeyFacet<{
    mailboxKey: typeof mailboxKeyFacet.type;
    filterState: string;
}> = new KeyFacet('mailboxFileSet', {
    mailboxKey: subKeyPart(mailboxKeyFacet),
    filterState: stringPart(),
});

export const mailboxFileSetPageKeyFacet: KeyFacet<{
    mailboxKey: typeof mailboxKeyFacet.type;
    offset: number;
    itemSetKey: string;
}> = new KeyFacet('mailboxFileSetPage', {
    mailboxKey: subKeyPart(mailboxKeyFacet),
    offset: numberPart(),
    itemSetKey: stringPart(),
});

export const fileKeyFacet: KeyFacet<{
    id: string;
    conversationId: string;
    conversationSubject: string;
    sender: string;
}> = new KeyFacet('file', {
    id: stringPart(),
    conversationId: stringPart(),
    conversationSubject: stringPart(),
    sender: stringPart(),
});
